import { render, staticRenderFns } from "./modal_edit_trend.vue?vue&type=template&id=649cc565&scoped=true&"
import script from "./modal_edit_trend.vue?vue&type=script&lang=js&"
export * from "./modal_edit_trend.vue?vue&type=script&lang=js&"
import style0 from "./modal_edit_trend.vue?vue&type=style&index=0&id=649cc565&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649cc565",
  null
  
)

export default component.exports